export function traderIdFromPathname(pathname: string, basePath: string): string | null {
  const rest = basePath && pathname.startsWith(basePath) ? pathname.slice(basePath.length) : pathname
  const first = rest.split('/').filter(Boolean)[0]
  if (!first || first === 'select-trader') return null
  return /^\d+$/.test(first) ? first : null
}
